export const nftCurrencyValues = ['eth'] as const;
export const nftDirectionValues = ['Asc', 'Desc'] as const;
// TODO: What is the criteria and usage of this "sort field"?
// Why is it different from `GroupItemSorts` type?
// Why do we only ever use a subset of that type?
export const nftSortValues = ['floor_price', 'purchase_date'] as const;

export enum NftFiltersKey {
    Name = 'name',
    CollectionName = 'collection_name',
    Collections = 'collections',
    Members = 'members',
    Ownership = 'ownership',
    Direction = 'direction',
    Sort = 'sort',
    Currency = 'currency',
    FloorPriceMin = 'floorPriceMin',
    FloorPriceMax = 'floorPriceMax',
    Spam = 'spam',
    Unsupported = 'unsupported',
}
